/**
 * Mode save truyền lên server để điều khiển
 */
export default {
  Save: 0,
  SaveNew: 1,
  SaveView: 2
};
